import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

import { hostSignedOutRoute, isHostAreaPath } from 'utils/host-area-access';
import { withNext } from 'utils/return-to';

const PortalProtector = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const { isLoggedIn, data: userData } = useSelector((state) => state.user) || {};

  useEffect(() => {
    const isInfluencerLoc = location.pathname?.includes('influencer');
    const isCreatorLoc = location.pathname?.includes('creator');
    const isAdminLoc = location.pathname?.includes('admin');
    const isAiTripPlanEditorLoc = location.pathname?.includes('itinerary-ai-plan-editor');
    const aiTripPlanId = searchParams.get('ai-trip-plan');

    if (!isLoggedIn) {
      if (isAiTripPlanEditorLoc && aiTripPlanId) {
        navigate(`/preview/ai-trip?ai-trip-plan=${aiTripPlanId}`);
      } else if (isHostAreaPath(location.pathname)) {
        // The host pages render in this layout, so this guard now speaks for
        // them too. It defers to the same rule their own entry guards use —
        // both effects fire in one commit, and a disagreement would bounce the
        // visitor twice. Signup for the recruiting URLs, login for the wizard.
        navigate(hostSignedOutRoute(location.pathname, location.search));
      } else if (location.pathname.startsWith('/messages')) {
        // A "New message" email's link (host-messaging-tech-design §8.2): sign
        // in, then straight back to the conversation.
        navigate(withNext('/login', `${location.pathname}${location.search}`));
      } else if (isCreatorLoc) {
        navigate('/creator/login');
      } else if (isInfluencerLoc) {
        navigate('/influencer/login');
      } else {
        navigate('/login');
      }
    } else if (
      ((isInfluencerLoc || isCreatorLoc) && userData.userType !== 'influencer' && userData.userType !== 'creator') ||
      (isAdminLoc && userData.userType !== 'admin')
    ) {
      // navigate('/my-apps');
    }
  }, [isLoggedIn, navigate, location, userData, searchParams]);

  return children;
};

export default PortalProtector;
